import { Button } from "@/components/ui/button";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import NavigationBar from "@/components/landing/NavigationBar";
import Footer from "@/components/landing/Footer";

const DataProcessing = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    // Check if we need to scroll to a specific section
    if (location.state && location.state.scrollToId) {
      const element = document.getElementById(location.state.scrollToId);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } else {
      // Otherwise scroll to top
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-gray-900">
      <NavigationBar />
      
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-6 text-white hover:bg-white/10"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>
        
        <h1 className="text-4xl font-bold mb-8 text-white">Data Processing Agreement</h1>
        
        <div className="space-y-8 text-gray-300">
          <section className="bg-gray-800/30 rounded-xl p-6">
            <h2 className="text-2xl font-semibold mb-4 text-white">1. Data Collection & Processing</h2>
            <p className="mb-4">
              This Data Processing Agreement ("DPA") forms part of the Terms of Service between you and AnalystX regarding the processing of personal data.
            </p>
            <p className="mb-4">
              AnalystX acts as a data processor for certain personal data that you submit to our services. We process this data solely for the purpose of providing our market intelligence and competitive analysis services.
            </p>
          </section>

          <section className="bg-gray-800/30 rounded-xl p-6">
            <h2 className="text-2xl font-semibold mb-4 text-white">2. Data Security Measures</h2>
            <p className="mb-4">
              We implement appropriate technical and organizational measures to ensure a level of security appropriate to the risk, including:
            </p>
            <ul className="list-disc pl-8 space-y-2 mb-4">
              <li>Encryption of personal data during transmission and at rest</li>
              <li>Regular testing and evaluation of security measures</li>
              <li>Ability to ensure ongoing confidentiality, integrity, and availability of processing systems</li>
              <li>Process for regularly testing security measures</li>
              <li>Measures to ensure physical security of data processing facilities</li>
            </ul>
          </section>

          <section className="bg-gray-800/30 rounded-xl p-6">
            <h2 className="text-2xl font-semibold mb-4 text-white">3. Subprocessors</h2>
            <p className="mb-4">
              AnalystX may engage subprocessors to process personal data on your behalf. We maintain a list of current subprocessors and will notify you of any intended changes concerning the addition or replacement of subprocessors.
            </p>
          </section>

          <section className="bg-gray-800/30 rounded-xl p-6">
            <h2 className="text-2xl font-semibold mb-4 text-white">4. Data Subject Rights</h2>
            <p className="mb-4">
              We will assist you in fulfilling your obligations to respond to data subjects' requests to exercise their rights under applicable data protection laws.
            </p>
          </section>

          <section className="bg-gray-800/30 rounded-xl p-6">
            <h2 className="text-2xl font-semibold mb-4 text-white">5. Related Policies</h2>
            <p className="mb-4">
              Please also review our <Link to="/privacy" className="text-blue-400 hover:underline">Privacy Policy</Link>, 
              <Link to="/terms" className="text-blue-400 hover:underline"> Terms of Service</Link>, and 
              <Link to="/cookie-policy" className="text-blue-400 hover:underline"> Cookie Policy</Link>.
            </p>
          </section>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default DataProcessing;
